import { Component, OnInit } from '@angular/core';
import { UserService, User } from 'src/app/services/management/user/user.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  constructor(public us: UserService) { }
  user: User;
  ngOnInit(): void {
  }

}
